// var scene = document.getElementById('scene');
// var parallaxInstance = new Parallax(scene);
// image parallax
gsap.registerPlugin(ScrollTrigger);  

const paraAspects = gsap.utils.toArray(".aspectholder")
if (paraAspects != null) {
	paraAspects.forEach(function(container) {
	let image = container.querySelector(".para");
		gsap.to(image, {
			y: "80%",
			ease: "none",
			// markers: true,
			scrollTrigger: {
				trigger: container,
				scrub: true,
				pin: false,
				// markers: true,
				invalidateOnRefresh: true,
			
			},
		}); 
	});
}


const sticker_hero = document.querySelector('.sticker_hero');
if (sticker_hero != null) {
	gsap.to('.stckr', {
		opacity: 1,
		ease: "power3.in",
		stagger: 0.08 // 0.1 seconds between when each ".box" element starts animating
	});
}



// toggle
function toggleActive(a, b) {
	document.querySelector(a).classList.toggle('active')
	if (b != null) {
		document.querySelector(b).classList.toggle('active')
	}

}

function toggleMenu(e) {
	const header = document.querySelector('header');
	header.classList.toggle('active');
	if (header.classList.contains('active')) {
		window.scrollBy(0, 36);
	}
	const mobSearch = document.querySelector('.mobile-search');
	mobSearch.classList.remove('active');
}
function showmobilesearchbar() {
	const mobSearch = document.querySelector('.mobile-search');
	mobSearch.classList.toggle('active');
}

// show granola
const granola = document.querySelector('.granola-holder');
if (granola !== null) {

	var prevScrollpos = window.pageYOffset;

	window.onscroll = function() {
		if(window.scrollY>=900){
			granola.classList.add('show')
		} else {
			granola.classList.remove('show')
		}
	}

}



// Product Card 
const ProductCards = document.querySelectorAll('.pcard.reg');
if (ProductCards != null) {
	for (let i = 0; i < ProductCards.length; i++) {
		const pcard = ProductCards[i];
		const frequencySelectContainer = pcard.querySelector('.subscribe__select-container')
		let frequencySelect = ""
		if (frequencySelectContainer) { 
			frequencySelect = frequencySelectContainer.querySelector('select')
			Array.from(pcard.querySelectorAll('.subscribe__select-container .product-purchase-option')).forEach((input) => { 
				input.addEventListener('change', (e) => { 
					handlePurchaseOptionChange(e)
				})
			})
		}
		function handlePurchaseOptionChange(e) {
			if (e.target.value === 'oneOff') { 
				frequencySelectContainer.classList.toggle('active')
				frequencySelect.name = ''
				// atcContainer.setAttribute('data-sub-active', false)
				isSubscription = false
				} else if (e.target.value === 'subscription') { 
				frequencySelectContainer.classList.toggle('active')
				frequencySelect.name = 'selling_plan'
				isSubscription = true
				// atcContainer.setAttribute('data-sub-active', true)
			}
		}


		// const pcardATC = pcard.querySelector('.card__image-atc');
		// pcardATC.addEventListener('mouseenter', () => {
		// 	gsap.to(pcardATC, {
		// 		height: "100%",
		// 		background: "#00000060",
		// 		duration: 0.4
		// 	})
		// })
		// pcardATC.addEventListener('mouseleave', () => {
		// 	gsap.to(pcardATC, {
		// 		height: 50,
		// 		background: "transparent",
		// 		duration: 0.2
		// 	})
		// })
	
	}


}









// swiper container
const SliderSwiper = document.getElementsByClassName('slider_block-swiper')
for (var i = 0; i < SliderSwiper.length; i++) {
	SliderSwiper[i].classList.add('swiperS' + i)

	const swiperNext =
    SliderSwiper[i].getElementsByClassName("prev");
	const swiperPrev =
	SliderSwiper[i].getElementsByClassName("next");

	if (swiperNext) {
		for (var s = 0; s < swiperNext.length; s++) {
		swiperNext[s].classList.add("next" + i);
		}
	}
	if (swiperPrev) {
		for (var s = 0; s < swiperPrev.length; s++) {
		swiperPrev[s].classList.add("prev" + i);
		}
	}

	var mySwiperP = new Swiper('.swiperS' + i, {
		direction: 'horizontal',
		loop: true,
		autoHeight: false,
		slidesPerView: 1,
		spaceBetween: 40,
		speed: 300,
		effect: "fade",
		centeredSlides: true,
		navigation: {
			nextEl: ".prev" + i,
			prevEl: ".next" + i,
		},
	})
}
// swiper container
const SliderImgSwiper = document.getElementsByClassName('slider_block-img-swiper')
for (var i = 0; i < SliderImgSwiper.length; i++) {
	SliderImgSwiper[i].classList.add('swiperI' + i)

	var mySwiperP = new Swiper('.swiperI' + i, {
		direction: 'horizontal',
		loop: true,
		slidesPerView: 1.4,
		spaceBetween: 20,
		centeredSlides: true,
		breakpoints: {
			900: {
				slidesPerView: 4.2,
				spaceBetween: 40,
			}
		},
		navigation: {
			nextEl: ".prev" + i,
			prevEl: ".next" + i,
		},
	})
}

	
const letters = gsap.utils.toArray(".footer-icon .letter");
const letterBox = document.querySelector(".footer-icon ")
gsap.to(letters, {
	y: -40,
	opacity: 1,
	stagger: 0.01,
	delay: "random(0, 0.05)",
	scrollTrigger: {
		trigger: letterBox,
		scrub: 2,
		pin: false,
		// markers: true,
		invalidateOnRefresh: true,
		end: "top: 40%"
	},
}); 




// header
const withSub = document.querySelectorAll('.main-nav-item');
const extendos = document.querySelectorAll('.extendo-menus');
const navBG = document.querySelector('.nav-bg');
for (let i = 0; i < withSub.length; i++) {
	const el = withSub[i];
	el.addEventListener('mouseenter', () => {
		const target = el.dataset.name;
		for (let i = 0; i < extendos.length; i++) {
			extendos[i].classList.remove('active');
			navBG.classList.remove('active');
		}
		if (el.classList.contains('has-sub')) {
			for (let i = 0; i < extendos.length; i++) {
				if (extendos[i].dataset.name == target) {
					extendos[i].classList.add('active')
					navBG.classList.add('active');
				}
			}
		}
		
	})
}
const header = document.querySelector('header');
header.addEventListener('mouseleave', () => {
	for (let i = 0; i < extendos.length; i++) {
		extendos[i].classList.remove('active')
		navBG.classList.remove('active');
	}
});


function showsearchbar() {
	const SearchForm = header.querySelector('.search-bar-form .search');
	const SearchBtn = header.querySelector('.showsearch');

	const showSearch = gsap.timeline();
	showSearch.to(SearchForm, {
		opacity: 1,
		visibility: "visible",
		duration: 0.2,
		ease: "ease"
	}).to(SearchBtn, {
		opacity: 0,
		visibility: "hidden",
		duration: 0.2,
		ease: "ease"
	}).to(SearchForm, {
		width: 200,
		duration: 0.5,
		ease: "back.out(1.7)",
	})
}





/* Swiper Initialiser */
const swiperContainerP = document.getElementsByClassName('carousel_product')
for (var i = 0; i < swiperContainerP.length; i++) {
	swiperContainerP[i].classList.add('swiperP' + i)

	const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination')

	if (swiperPage) {
		swiperPage.classList.add('pageP' + i)
	}

	var mySwiperP = new Swiper('.swiperP' + i, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		speed: 300,
		centeredSlides: true,
		pagination: {
			el: '.pageP' + i,
			clickable: true,
		},
	})
}

/* Toggle Class (Generic) */
function toggleClass(modalName) {
	var modalActive = document.querySelector(modalName)
	modalActive.classList.toggle('active')
}

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
	var formQ = document.querySelector(formId)

	if (quantity == '+') {
		Number(formQ.value++)
	} else if (quantity == '-' && formQ.value > 1) {
		Number(formQ.value--)
	}
}

/* Open Cart */
const body = document.querySelector('body')
function cartOpen() {
	body.classList.add('js-my-cart-open')
}

/* Details Animator */
const details = document.querySelectorAll('details')

if (details) {
	details.forEach((targetDetail) => {
		targetDetail.querySelector('summary').addEventListener('click', function (e) {
			if (targetDetail.hasAttribute('open')) {
				e.preventDefault()
				targetDetail.classList.add('closing')
				setTimeout(() => {
					targetDetail.removeAttribute('open')
					targetDetail.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* Orphan Remove and LSEP Removal */
// var nbspSelectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'span']
// var nbspWordMin = 10 //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
// 	var nbspElements = document.querySelectorAll(selector)
// 	nbspElements.forEach(function (element) {
// 		element.innerHTML = element.innerHTML.replace(/\u2028/g, '')
// 		element.innerHTML = element.innerHTML.replace(/&#8232;/g, '')
// 		var wordCount = element.innerHTML.split(' ').length
// 		if (wordCount >= nbspWordMin) {
// 			element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, '&nbsp;$1')
// 		}
// 	})
// })

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({

})

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const btn = form.querySelector('button[type="submit"]')
		if (btn) {
			btnInner = btn.innerHTML
			btn.innerHTML = 'ADDING'
		}

		subscribeToResult((state) => {
			const btn = form.querySelector('button[type="submit"]')
			if (state.responseData.ok) {
				cartOpen()
			}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})

/* enterview */
/* Load video on enter */
// const llVideos = document.querySelectorAll('video.lazy')

// if (llVideos.length > 0) {
// 	enterView({
// 		selector: '.video-ll',
// 		enter: function (el) {
// 			el.load()
// 			el.play()
// 		},
// 		offset: 0.1,
// 	})
// }

var b = document.querySelector(".enter");
if (b) {
	enterView({
		selector: '.enter',
		enter: function (el) {
			el.classList.add('entered');
		},
		exit: function (el) {
			el.classList.remove('entered');
		},
		offset: 0.1,
	});
}


// footer

// gsap.utils.toArray(".footer-icon").forEach(function(conta) {
// 	let letter = conta.querySelector(".letter");
// 		gsap.to(letter, {
// 			x: "100px",
// 			ease: "none",
// 			// markers: true,
// 			scrollTrigger: {
// 				trigger: conta,
// 				scrub: true,
// 				pin: false,
// 				markers: true,
// 				start: "top bottom",
// 				end: "bottom bottom",
// 				invalidateOnRefresh: true,
	
// 			},
// 		}); 
// });



// Blog
function sortArticles(e, a) {
	const sorters = document.querySelectorAll('.sort-btn');
	for (let i = 0; i < sorters.length; i++) {
		sorters[i].classList.remove('active');
	}
	e.classList.add('active');
	const blog = document.querySelector('.blog__articles');
	(a === 'old') ? blog.classList.add('reversed') : blog.classList.remove('reversed');
}

function showArticles(e, a) {
	const filters = document.querySelectorAll('.filter-btn');
	for (let i = 0; i < filters.length; i++) {
		filters[i].classList.remove('active');
	}
	e.classList.add('active');

	const ac = document.querySelectorAll('.article-card');
	for (let i = 0; i < ac.length; i++) { 
		(ac[i].classList.contains(a)) ? ac[i].classList.remove('hide') : ac[i].classList.remove('hide');
		if (ac[i].classList.contains(a)) {
			ac[i].classList.remove('hide');
			ac[i].classList.add('entered');
		}	else {
			ac[i].classList.add('hide');
		}
	}
}